export const translationsUY = {
  'es-UY': {
    country: 'barrio privado',
    project: 'Pozo',
    sign: 'Cartel',
    remodeled: 'Refaccionado',
    toRemodel: 'A refaccionar',
    garage: 'Cochera',
    departament: 'Apartamento', // pasarlo a property type
    propertyTypes: {
      "Departamento Dúplex":'Apartamento Dúplex',
      "Departamento Estándar": 'Apartamento Estándar',
      "Departamento Loft": 'Apartamento Loft',
      "Departamento Monoambiente": 'Apartamento Monoambiente',
      "Departamento Penthouse": 'Apartamento Penthouse',
      "Departamento Piso": 'Apartamento Piso',
      "Departamento SemiPiso": 'Apartamento SemiPiso',
      "Departamento Triplex": 'Apartamento Triplex',
      "PH": 'PH',
      "Casa": 'Casa',
      "Terrenos y Lotes": 'Terrenos y Lotes',
      "Quinta": 'Quinta',
      "Local": 'Local',
      "Hotel": 'Hotel',
      "Oficina": 'Oficina',
      "Galpón": 'Galpón',
      "Camas Nauticas": 'Camas Nauticas',
      "Edificio": 'Edificio',
      "Campo": 'Campo',
      "Otros Inmuebles": 'Otros Inmuebles',
      "Casa Dúplex": 'Casa Dúple',
      "Fondo de comercio": 'Fondo de comercio',
      "Cochera": 'Cochera',
      "Parcelas, Nichos y Bovedas": 'Parcelas, Nichos y Bovedas',
      "Casa Triplex": 'Casa Triplex',
      "Chacra": 'Chacra',
      "Consultorio": 'Consultorio',
      "Deposito": 'Deposito',
    }
  },
};
